<template>
  <div>
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <template v-for="(item,index) in levelList">
          <el-breadcrumb-item :key="index" v-if="item.meta && item.meta.title">
            <router-link v-if="item.path" :to="item.path">
              {{ $t('sideBar.'+item.meta.title) }}
            </router-link>
            <span v-else>{{ $t('sideBar.'+item.meta.title) }}</span>
          </el-breadcrumb-item>
        </template>
      </transition-group>
    </el-breadcrumb>
  </div>

</template>

<script>
// import { generateTitle } from '@/utils/i18n'
import pathToRegexp from 'path-to-regexp'
import { constantRoutes } from '@/router'

export default {
  data () {
    return {
      levelList: []
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  },
  watch: {
    path () {
      this.initData()
    }
  },
  mounted () {
    console.log(constantRoutes)
    this.initData()
  },
  methods: {
    initData () {
      this.levelList = [{ path: '/', meta: { title: 'HOME' } }]
      if (this.$route.path != '/' && this.$route.path != '/dashboard') {
        const arr = this.path.split('/')
        if (arr[1]) {
          const parent = constantRoutes.find(item => item.path == '/' + arr[1])
          if (parent && parent.children) {
            this.levelList.push({ path: parent.path, meta: { title: parent.name } })
          }
        }
        this.levelList.push({ path: '', meta: this.$route.meta })
      }
    },
    // generateTitle,
    getBreadcrumb () {
      // only show routes with meta.title
      // console.log('this.$route--', this.$route)
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      console.log('matched', matched)
      const first = matched[0]

      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: 'HOME' } }].concat(matched)
      }

      console.log('matched--index--', matched)
      matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      /* 处理：在菜单栏显示的一级菜单和二级菜单 显示问题
        * matched.length: 首页=1 一级菜单=3 二级菜单=3 无导航=2
        * 由于一级菜单和二级菜单都会出现三层显示，如：HOME/DEVICES/DEVICES  而一级菜单只应该显示HOME/DEVICES,所以matched里删除最后一项：matched.splice(2, 1)
        * 由于QR和setting包含三级菜单，需要三层显示，所以排除它们：matched[1].name != 'QR' && matched[1].name != 'setting'
        */
      if (matched.length > 2 && matched[1].redirect == matched[2].path && matched[1].name != 'QR' && matched[1].name != 'setting' && matched[1].name != 'blueTooth' && matched[1].path != '/kisae' && matched[1].path != '/sim' && matched[1].path != '/lease') {
        matched.splice(2, 1)
      }
      /* 处理：二级菜单下的页面 里的子菜单 显示问题
        * 如：处理前，显示的是 ：首页/设置/子公司，而当前页应该是：首页/设置/公司/子公司
        * 所以matched里添加子公司的父级页面--公司：matched.splice(2, 0，{})
        * 由于在当前情况下，setting只有path：'/setting',页面无法跳转，所以需要给一个指向setting的默认指向路由'/setting/menuSetting'，
        *     但由于权限问题，用户可能没有/setting/menuSetting权限，所以改为this.$store.state.routes中的指向
      */
      if (matched.length >= 3 && (matched[1].path == '/QR' || matched[1].name == 'setting' || matched[1].name == 'blueTooth' || matched[1].path == '/kisae' || matched[1].path == '/sim')) {
        if (matched[2].parent) {
          if (matched[2].parent.path == '/setting' && (matched[2].name == 'childCompany' || matched[2].name == 'companyUser')) {
            matched.splice(2, 0, {
              meta: {
                icon: '',
                title: 'COMPANY'
              },
              name: undefined,
              parent: undefined,
              path: '/setting/companyIndex',
              redirect: undefined
            })
            this.$store.state.routes.forEach(v => {
              if (v.path == '/setting') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                // if (!matched[1].redirect)matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/setting' && (matched[2].name == 'fwUpdateDetail')) {
            matched.splice(2, 0, {
              meta: {
                icon: '',
                title: 'FWUPDATE'
              },
              name: undefined,
              parent: undefined,
              path: '/setting/fwUpdateIndex',
              redirect: undefined
            })
            this.$store.state.routes.forEach(v => {
              if (v.path == '/setting') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                // if (!matched[1].redirect)matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/setting' && (matched[2].name == 'curveDetail')) {
            matched.splice(2, 0, {
              meta: {
                icon: '',
                title: 'CURVE'
              },
              name: undefined,
              parent: undefined,
              path: '/setting/curveIndex',
              redirect: undefined
            })
            this.$store.state.routes.forEach(v => {
              if (v.path == '/setting') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                // if (!matched[1].redirect)matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/QR' && (matched[2].name == 'chargerReportDetail')) {
            matched.splice(2, 0, {
              meta: {
                icon: '',
                title: 'CHARGELOG'
              },
              name: undefined,
              parent: undefined,
              path: '/QR/charges',
              redirect: undefined
            })
            this.$store.state.routes.forEach(v => {
              if (v.path == '/QR') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                // if (!matched[1].redirect)matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/blueTooth') {
            console.log('matched', matched)
            if (matched[2].name == 'chargeDataDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'btChargeData'
                },
                name: undefined,
                parent: undefined,
                path: '/blueTooth/btChargeData',
                redirect: undefined
              })
            }
            if (matched[2].name == 'yhubDataDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'btYhubData'
                },
                name: undefined,
                parent: undefined,
                path: '/blueTooth/btYhubData',
                redirect: undefined
              })
            }
            if (matched[2].name == 'liBatteryData') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'btLiBatteryIndex'
                },
                name: undefined,
                parent: undefined,
                path: '/blueTooth/btLiBatteryIndex',
                redirect: undefined
              })
            }
            this.$store.state.routes.forEach(v => {
              if (v.path == '/blueTooth') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                // if (!matched[1].redirect)matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/kisae') {
            if (matched[2].name == 'kisaeDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'KISAEINDEX'
                },
                name: undefined,
                parent: undefined,
                path: '/kisae/kisaeIndex',
                redirect: undefined
              })
            }
            if (matched[2].name == 'kisaeDataDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'KISAEDATA'
                },
                name: undefined,
                parent: undefined,
                path: '/kisae/kisaeDataIndex',
                redirect: undefined
              })
            }
            this.$store.state.routes.forEach(v => {
              if (v.path == '/kisae') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                if (!matched[1].redirect) matched[1].redirect = v.redirect
              }
            })
          } else if (matched[2].parent.path == '/sim') {
            if (matched[2].name == 'simDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'simMagt'
                },
                name: undefined,
                parent: undefined,
                path: '/sim/simIndex',
                redirect: undefined
              })
            }
            if (matched[2].name == 'deviceDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'deviceMagt'
                },
                name: undefined,
                parent: undefined,
                path: '/sim/deviceIndex',
                redirect: undefined
              })
            }
            if (matched[2].name == 'orderDetail') {
              matched.splice(2, 0, {
                meta: {
                  icon: '',
                  title: 'orderMagt'
                },
                name: undefined,
                parent: undefined,
                path: '/sim/orderIndex',
                redirect: undefined
              })
            }
            this.$store.state.routes.forEach(v => {
              if (v.path == '/sim') {
                // 选择一：首页/设置/固件更新/详情 中,点击 设置 跳转到 固件更新 列表页
                v.children.forEach(m => {
                  if (matched[2].path == v.path + '/' + m.path) matched[1].redirect = matched[2].path
                })
                // 选择二：首页/设置/固件更新/详情 中,点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
                if (!matched[1].redirect) matched[1].redirect = v.redirect
              }
            })
          }
        }
      }
      /* 处理：二级菜单中中间路由的跳转问题
        * 如：处理前，显示的是 ：首页/设置/固件更新，点击 设置 跳转到setting目录下有权限的第一项，如当前用户setting中的权限第一项为公司，则跳转到公司列表页
        *     将它改为：点击设置，跳转到 固件更新 列表页
      */
      if (matched.length >= 3 && (matched[1].path == '/QR' || matched[1].name == 'setting' || matched[1].name == 'blueTooth' || matched[1].name == 'kisae' || matched[1].path == '/sim' || matched[1].path == '/lease')) {
        if (matched[2].parent) {
          // if (matched[2].name != 'childCompany' && matched[2].name != 'companyUser' && matched[2].name != 'fwUpdateDetail' && matched[2].name != 'chargerReportDetail' && matched[2].name != 'btChargeDataDetail' && matched[2].name != 'kisaeDataDetail' && matched[2].name != 'trafficDetail') {
          if (matched[2].name != 'childCompany' && matched[2].name != 'companyUser' && matched[2].name != 'fwUpdateDetail' && matched[2].name != 'chargerReportDetail' && matched[2].name != 'btChargeDataDetail' && matched[2].name != 'kisaeDataDetail') {
            matched[1].redirect = matched[2].path
          }
        }
      }
      /* 处理：无导航 显示问题
        * matched.length: 首页=1 一级菜单=3 二级菜单=3 无导航=2
        * 由于无导航url都是通过页面跳转进去的，应该显示三层，所以matched里中间添加一项（该路由的父级路由）：matched.splice(1, 0, newObj)
        */
      var newObj = {}
      if (matched.length == 2 && matched[1].parent) {
        this.$store.state.routes.forEach(m => {
          // console.log('matched[1].parent.path--', matched[1].parent.path)
          if (matched[1].parent.path == m.path) {
            console.log('m--', m)
            newObj = {
              meta: {
                icon: '',
                title: m.meta.title
              },
              name: undefined,
              parent: undefined,
              path: m.path,
              redirect: m.redirect
            }
          }
        })
        matched.splice(1, 0, newObj)
      }
      this.levelList = matched
      // console.log('this.levelList--', this.levelList)
    },
    isDashboard (route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile (path) {
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink (item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
